import Modal from '../Utils/Modal';
import '../../styles/formCalculatorModal.scss';
import { connect } from 'react-redux';
import 'rc-slider/assets/index.css';
import Options from '../Resources/integrationNew/Integration/Main/Details/FormCalculatorStyling/Modal/Options';
import Preview from '../Resources/integrationNew/Integration/Main/Details/FormCalculatorStyling/Modal/Preview';
import { useState, useCallback } from 'react';

const FormAndCalculatorStylingModal = (props) => {
  const [activeTab, setActiveTab] = useState('form');
  const handleActiveTab = useCallback((tab) => {
    setActiveTab(tab);
  }, []);

  return (
    <Modal extraClass='formCalculatorStyling' {...props}>
      <div className='modal-container'>
        <div className='integration__formCalculatorStyling'>
          <div className='integration__formCalculatorStyling--options'>
            <Options onRequestClose={props.onRequestClose} selectedTab={handleActiveTab} />
          </div>
          <div className='integration__formCalculatorStyling--preview'>
            <Preview selectedTab={activeTab} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default connect((state) => state)(FormAndCalculatorStylingModal);
